var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.viewMode
        ? _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "bottom-line width-1-5x",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.classifyTagName,
                      callback: function($$v) {
                        _vm.classifyTagName = $$v
                      },
                      expression: "classifyTagName"
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                    attrs: { title: "选择归类标签" },
                    on: {
                      click: function($event) {
                        _vm.selectTag()
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("swb-prop-editor", {
        ref: "prop_editor",
        attrs: {
          name: "demo-prop-editor",
          widthForLabel: 150,
          propList: _vm.propList,
          viewMode: _vm.viewMode
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("归类标签")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d8af1d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d8af1d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcCust/DevcCustInfoSave.vue
// module id = 2454
// module chunks = 0